var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scanner-container"},[_c('div',{staticClass:"scan btn-start",on:{"click":_vm.handleScanCode}},[_vm._v("扫一扫获取结果")]),(_vm.scanResult)?_c('div',{staticClass:"result-box"},[_vm._m(0),_c('p',{staticClass:"result-text",domProps:{"innerHTML":_vm._s(_vm.scanResult)}})]):_vm._e()])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_c('strong',[_vm._v("扫描结果：")])])
}]

export { render, staticRenderFns }